import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CmdbNodeDataModel} from "../../cmdb-node-data.model";

@Component({
  selector: 'sb-cmdb-default-infobox',
  templateUrl: './cmdb-default-infobox.component.html',
  styleUrls: ['./cmdb-default-infobox.component.scss']
})
export class CmdbDefaultInfoboxComponent implements OnInit, OnDestroy {

  @Input()
  data: CmdbNodeDataModel;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  iconMarkup() {
    let markup = "";
    if (this.data.iconName) {
      markup = `<i class="mi cmdb-default-infobox-mi-icon">${this.data.iconName}></i>`;
    }
    return markup;
  }
}
